export default "__VITE_ASSET__23abbe8a__"